import axios from 'axios';

export const verifiedCodeUVM = async code => {
  let info = await axios.get(
    `${process.env.REACT_APP_API_PATH_VERIFIED}/verify/code`,
    {
      params: { code }
    }
  );
  if (info.data) {
    return info.data.verified;
  } else {
    return 'error';
  }
};

export const verifiedData = async (
  idAcademy,
  idCourse,
  idUserProgress
) => {
  let info = await axios.get(
    `${process.env.REACT_APP_API_PATH_VERIFIED}/diploma/details`,
    {
      params: { idAcademy, idCourse, idUserProgress }
    }
  );
  if (info.data.userDiploma) {
    return info.data.userDiploma;
  }
  return false;
};

export const getUrlDiploma = async id => {
  let url = await axios.get(
    `${process.env.REACT_APP_API_PATH_VERIFIED}/diploma/url`,
    {
      params: { id }
    }
  );
  if (url.data.location) {
    return url.data.location;
  }
  return false;
};
